const STORAGE_KEY = "gem_chat_session_v1";

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `s_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

/** Anonymous chat correlation id (tab session); backend may tighten format. */
export function getPersistedChatSessionId() {
  try {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id || String(id).length < 8) {
      id = randomId();
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return String(id).trim();
  } catch {
    return randomId();
  }
}

export function setPersistedChatSessionId(id) {
  if (!id || String(id).length < 8) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, String(id).trim());
  } catch (_) {}
}
